import React, { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { api, fmtPrice } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function OrderSuccess() {
  const { id } = useParams();
  const location = useLocation();
  const { t } = useLang();
  const [order, setOrder] = useState(location.state?.order || null);

  useEffect(() => {
    if (!order) api.get(`/orders/${id}`).then((r) => setOrder(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, [id]); // eslint-disable-line

  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center" data-testid="order-success">
      <div className="w-20 h-20 rounded-full bg-emerald-100 grid place-items-center mx-auto mb-6 fade-up">
        <CheckCircle2 className="w-11 h-11 text-emerald-700" />
      </div>
      <h1 className="font-display font-extrabold text-3xl tracking-tight mb-3">{t("order_success")}</h1>
      <p className="text-stone-500 mb-6">{t("order_success_sub")}</p>
      {order && (
        <div className="bg-white border border-stone-200 rounded-xl p-6 text-left mb-6">
          <div className="flex justify-between mb-2"><span className="text-stone-500 text-sm">{t("order_no")}</span><span className="font-display font-bold" data-testid="success-order-no">{order.order_no}</span></div>
          <div className="flex justify-between"><span className="text-stone-500 text-sm">{t("total")}</span><span className="font-display font-extrabold text-emerald-800">{fmtPrice(order.total)}</span></div>
        </div>
      )}
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/orders"><Button className="rounded-full bg-emerald-800 hover:bg-emerald-900" data-testid="view-orders-btn">{t("view_orders")}</Button></Link>
        <Link to="/"><Button variant="outline" className="rounded-full">{t("back_home")}</Button></Link>
      </div>
    </div>
  );
}
